import React from 'react';

const colors = {
  pageBg: '#F5F0FD',
  badgeBg: '#EAE0FD',
  badgeText: '#6D28D9',
  headingDark: '#14121F',
  headingPurple: '#7209B7',
  paragraph: '#5F5D72',
  cardText: '#1F1D2B',
};

const FeatureCard = ({ imgSrc, line1, line2 }) => (
  <div
    style={{
      backgroundColor: '#FFFFFF',
      boxShadow: '0 8px 24px rgba(124,58,237,0.06)',
    }}
    className="rounded-[20px] p-3 pr-5 flex items-center gap-3 w-full lg:w-auto lg:min-w-[158px] justify-start"
  >
    <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0">
      <img src={imgSrc} alt={line1} className="w-full h-full object-contain" />
    </div>
    <span style={{ color: colors.cardText }} className="font-semibold text-[13px] sm:text-[14px] leading-[1.15] text-left">
      {line1}
      <br />
      {line2}
    </span>
  </div>
);

const CommunityGuidelinesWelcome = () => {
  return (
    <div
      style={{ backgroundColor: colors.pageBg }}
      className="relative w-full overflow-hidden min-h-[900px] lg:min-h-[680px]"
    >
     

      {/* Mobile background */}
<div
  className="lg:hidden absolute inset-0 bg-cover bg-bottom bg-no-repeat "
  style={{ backgroundImage: "url('/img/community-guidelines/CommunityMobile.png')" }}
/>

{/* Desktop background */}
<div
  className="hidden lg:block absolute inset-0 bg-cover bg-right-bottom bg-no-repeat"
  style={{ backgroundImage: "url('/img/community-guidelines/Community.png')" }}
/>


    

      {/* Content — simply on the left */}
      <div className="relative z-10 flex flex-col items-center lg:items-start text-center lg:text-left gap-4 lg:gap-6 pt-24 lg:pt-48 px-6 sm:px-8 lg:px-12 lg:max-w-[50%]">

        {/* Badge */}
        <div
          style={{ backgroundColor: colors.badgeBg, color: colors.badgeText }}
          className="inline-flex items-center justify-center gap-2 font-semibold text-[12px] sm:text-[13px] px-4 py-1.5 rounded-full "
        >
          <img src="/img/community-guidelines/CommunityGuidelines.svg" alt="Community Guidelines" className="w-3.5 h-3.5" />
          Community Guidelines
        </div>

        {/* Heading */}
        <h1 className="font-extrabold tracking-tight leading-[1.08]">
          <span className="block whitespace-nowrap text-[7vw] sm:text-[6vw] md:text-[3.2vw] lg:text-[3vw]" style={{ color: colors.headingDark }}>
            Welcome to the
          </span>
          <span className="block whitespace-nowrap text-[7vw] sm:text-[6vw] md:text-[3.2vw] lg:text-[3vw]" style={{ color: colors.headingDark }}>
            <span style={{ color: colors.headingPurple }}>SoloConnect</span> Community
          </span>
        </h1>

        {/* Paragraph */}
        <p
          style={{ color: colors.paragraph }}
          className=" text-[15px] md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 font-medium"
        >
          SoloConnect is built to help solo travelers connect,
          explore, and create meaningful travel experiences
          together. Our community is based on respect, trust,
          and safety, ensuring every traveler enjoys a secure
          and welcoming environment.
        </p>

        {/* Feature Cards — mobile */}
        <div className="flex flex-col items-center gap-3 mt-3 w-full lg:hidden px-2 sm:px-6">
          <div className="flex flex-row justify-center gap-3 w-full">
            <FeatureCard imgSrc="/img/community-guidelines/Feature1.svg" line1="Respect" line2="Everyone" />
            <FeatureCard imgSrc="/img/community-guidelines/TravelSafely.svg" line1="Travel" line2="Safely" />
          </div>
          <div className="flex justify-center w-full max-w-[180px]">
            <FeatureCard imgSrc="/img/community-guidelines/ConnectMeaningfully.svg" line1="Connect" line2="Meaningfully" />
          </div>
        </div>

        {/* Feature Cards — desktop */}
        <div className="hidden lg:flex flex-wrap justify-start gap-4 mt-2 w-full">
          <FeatureCard imgSrc="/img/community-guidelines/Feature1.svg" line1="Respect" line2="Everyone" />
          <FeatureCard imgSrc="/img/community-guidelines/TravelSafely.svg" line1="Travel" line2="Safely" />
          <FeatureCard imgSrc="/img/community-guidelines/ConnectMeaningfully.svg" line1="Connect" line2="Meaningfully" />
        </div>
      </div>
    </div>
  );
};

export default CommunityGuidelinesWelcome;